import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class OnboardingManagerService {
  api_url = environment.SERVER_URL + 'icrweb/home/';
  constructor(
    private http: HttpClient
  ) {

  }

  getDynamicSections(request) {
    return this.http.post(this.api_url + 'get_myjourney_onboarding_form_details', request);
  }
  saveSection(request) {
    return this.http.post(this.api_url + 'submit_myjourney_onboarding_form_details', request);
  }
  getApplicantSummary(request) {
    return this.http.post(this.api_url + 'get_resumeSummary', request);
  }
  getRequirementSummary(request) {
    return this.http.post(this.api_url + 'get_productJobSummary', request);
  }
  getMasterTable(request) {
    return this.http.post(this.api_url + 'get_master_data_of_table', request, {
      headers: {
        header_type: '2'
      }
    });

  }
  generateOnbAppointmentLetter(obj, header_type?) {
    return this.http.post(environment.VIEWER_URL + 'icrweb/home/save_generate_onboarding_appointment_letter', obj, {
      headers: {
        header_type: header_type || '1'
      }
    });
  }

  getMasters(route, obj) {
    return this.http.post(environment.SERVER_URL + 'icrweb/home/' + route, obj, {
      "headers": {
        "header_type": "2"
      }
    });
  }
  suffixActionFunction(url, request) {
    return this.http.post(this.api_url + url, request, {
      headers: {
        header_type: '1'
      }
    });
  }

  getStatusLog(request) {
    return this.http.post(this.api_url + 'get_offer_onboarding_verification_data', request)
  }
}
